<template>
  <svg style="margin-top: 4px; margin-right: 7.1px" :width="width" :height="height" 
    viewBox="0.5 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.4213 4.51562H9.68846C9.52909 4.51562 9.37753 4.59219 9.28378 4.72344L6.82752 8.12969L5.71501 6.58594C5.62126 6.45625 5.47126 6.37813 5.31032 6.37813H4.57751C4.47595 6.37813 4.41657 6.49375 4.47595 6.57656L6.42283 9.27656C6.46882 9.34076 6.52945 9.39306 6.59969 9.42914C6.66994 9.46523 6.74777 9.48405 6.82674 9.48405C6.9057 9.48405 6.98354 9.46523 7.05378 9.42914C7.12402 9.39306 7.18465 9.34076 7.23064 9.27656L10.5213 4.71406C10.5822 4.63125 10.5228 4.51562 10.4213 4.51562Z" fill="url(#paint0_linear_6123_279)"/>
    <path d="M7.5 0C3.63438 0 0.5 3.13438 0.5 7C0.5 10.8656 3.63438 14 7.5 14C11.3656 14 14.5 10.8656 14.5 7C14.5 3.13438 11.3656 0 7.5 0ZM7.5 12.8125C4.29063 12.8125 1.6875 10.2094 1.6875 7C1.6875 3.79063 4.29063 1.1875 7.5 1.1875C10.7094 1.1875 13.3125 3.79063 13.3125 7C13.3125 10.2094 10.7094 12.8125 7.5 12.8125Z" fill="url(#paint1_linear_6123_279)"/>
    <defs>
      <linearGradient id="paint0_linear_6123_279" x1="7.5" y1="0" x2="7.5" y2="14" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF"/>
        <stop offset="1" stop-color="#D62FA0"/>
      </linearGradient>
      <linearGradient id="paint1_linear_6123_279" x1="7.5" y1="0" x2="7.5" y2="14" gradientUnits="userSpaceOnUse">
        <stop stop-color="#762ECF"/>
        <stop offset="1" stop-color="#D62FA0"/>
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "CheckAIIcon",
  props: {
    width: {
      type: String,
      required: false,
      default: '15'
    },
    height: {
      type: String,
      required: false,
      default: '15'
    }
  },
};
</script>

<style lang="sass" scoped></style>
